
import React, {
    Fragment,
    useState,
    useEffect,
    useRef,
    useMemo,
    useCallback,
  } from "react";
  import {
    subscriptionReportsList,
    getMlmfoutletMaster,
    downloadTemplateExcelDownloadSubscription

  } from "../../../../apiservicescall/api";
  import Table from "@mui/material/Table";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import MUIDataTable from "mui-datatables";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/Step";
import StepButton from "@material-ui/core/StepButton";
import RctCollapsibleCard from "../RctCollapsibleCard/RctCollapsibleCard";
  import {
    // Table,
    Badge,
    Row,
    Card,
    Col,
    Button,
    Container,
    ListGroup,
    Tab,
  } from "react-bootstrap";
  import { Link } from "react-router-dom";
  
  import Select from "react-select";
  
  import {
    Pagination,
    PaginationItem,
    PaginationLink,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
  } from "reactstrap";
  import swal from "sweetalert";
  import { Form, FormGroup, Label, Input } from "reactstrap";
  import {
    KeyboardDatePicker,
    MuiPickersUtilsProvider,
  } from "@material-ui/pickers";
  import DateFnsUtils from "@date-io/date-fns";
  import DatePicker from "react-datepicker";
  import "react-datepicker/dist/react-datepicker.css";
  import { Edit } from "@material-ui/icons";
  import {
    CloudDownload,
    FormatBold,
    TramRounded,
    CloudDownloadOutlined,
    ArrowDownward,
    ArrowDownwardRounded,
  } from "@material-ui/icons";
  import { NotificationManager } from "react-notifications";
  import IconButton from "@material-ui/core/IconButton";
  import { TableRow, Tooltip } from "@material-ui/core";
  import  RctSectionLoader from "../RctSectionLoader/RctSectionLoader";


const SubscriptionReports = () => {

    const [selectedrestarant, setSelectedrestarant] = useState([
        { label: "", value: "" },
      ]);

      const [outletlist, setoutletlist] = useState([]);

      const [startDate, setDate] = useState(new Date());
      const [endDate, setendDate] = useState(new Date());
      const [reports, setReports] = useState([]);
      const [listmast, setListmast] = useState(false);
      const [loader, setLoader] = useState(false);

      const today = new Date();


    useEffect(() => {
      
        getRestarantmaster();
      }, []);

      const [currentPage, setCurrentPage] = useState(0);
      const [totalPages, setTotalPages] = useState(0);
      const [totalItems, setTotalItems] = useState(0);
      const [itemsPerPage, setItemsPerPage] = useState(10);
      const [approvalpopup, setApprovalPopup] = useState(false);

    const getRestarantmaster = async () => {
        let getsoutletList = await getMlmfoutletMaster();
    
        let getsoutletValue = (getsoutletList && getsoutletList.data.data) || [];
    
        let restarantmaster = getsoutletValue.map(({ id, name }) => ({
          label: name,
          value: id,
        }));
        // console.log("restarantmaster", restarantmaster);
        setoutletlist(restarantmaster);
      };
    

      const getSubscrptionReportsList = async () => {
        let outletCode = selectedrestarant.value||"";

        let fromdate =
          startDate.getFullYear() +
          "-" +
          (startDate.getMonth() + 1) +
          "-" +
          startDate.getDate()||new Date();

        let todate =
          endDate.getFullYear() +
          "-" +
          (endDate.getMonth() + 1) +
          "-" +
          endDate.getDate()||new Date();



        let getplanList = await subscriptionReportsList(outletCode,fromdate,todate,);
         console.log("getplanList",getplanList);
        let getplanidValue = getplanList.data.data || [];

         setReports(getplanidValue);

        // let Selectedplan = getplanidValue.map(({ planId, planName }) => ({
        //   label: planName,
        //   value: planId,
        // }));
        // setSubPlanId(Selectedplan);
      };

    const exceldownload = async () => {


      let outletCode = selectedrestarant.value || "";

      let fromdate =
        startDate.getFullYear() +
          "-" +
          (startDate.getMonth() + 1) +
          "-" +
          startDate.getDate() || new Date();

      let todate =
        endDate.getFullYear() +
          "-" +
          (endDate.getMonth() + 1) +
          "-" +
          endDate.getDate() || new Date();

      let downloadSubscripReport =
      
        await downloadTemplateExcelDownloadSubscription(
          fromdate,
          todate,
          outletCode
        );
      console.log("downloadSubscripReport", downloadSubscripReport);

      if (downloadSubscripReport && downloadSubscripReport.status === 200) {
        NotificationManager.success("Downloaded");
        const url = window.URL.createObjectURL(
          new Blob([downloadSubscripReport.data])
        );
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `ReportMaster_${new Date().getDate()}${
            new Date().getMonth() + 1
          }${new Date().getFullYear()}.xls`
        );
        link.click();
        setTimeout(() => window.URL.revokeObjectURL(url), 0);
        // setLoader(false);
        // await this.setState({ reload: false });
        // this.getSpecialSchemeList();
      } else {
        //await this.setState({ reload: false });
        NotificationManager.error("error");
        // setLoader(false);
      }
    };
    
  const handleChangePage = (event, newPage) => {
    setCurrentPage(newPage);
  };

  const onChangeRowsPerPage = (numOfRows) => {
    // let { currentPage, itemsPerPage } = this.state;
    setItemsPerPage(numOfRows);
  };
    const options = {
      filter: true, 
      search: true, 
      selectableRows: false,
      responsive: "stacked",
      fixedHeader: true,
      tableBodyHeight: "60vh",
      fixedSelectColumn: true,
      page: currentPage,
      pagination: true,
      serverSide: false,
      rowsPerPage: itemsPerPage,
      rowsPerPageOptions: [10, 15, 100],
      onChangePage: (newPage) => {
        handleChangePage(newPage);
      },
      onChangeRowsPerPage: (numOfRows) => {
        onChangeRowsPerPage(numOfRows);
      },
      download: false,
      print: false,
      onFilterChange: (column, filterList, type, filterOptions, changedColumnIndex) => {
        
      },
      confirmFilters: true,
      customFilterDialogFooter: (currentFilterList, applyNewFilters) => {
        return (
          <div style={{ marginTop: "40px" }}>
            <Button
              variant="contained"
              onClick={() => applyNewFilters()} 
            >
              Apply Filters
            </Button>
          </div>
        );
      },
      onFilterConfirm: (filterList) => {
        // Handle filter confirmation here if needed
      },
      onFilterDialogOpen: () => {
        // Handle filter dialog open event if needed
      },
      onFilterDialogClose: () => {
        // Handle filter dialog close event if needed
      },
      customToolbar: () => {
        return (
          <>
            {
             
            }
          </>
        );
      },
    };
    const columns = [
      {
        name: "outletName",
        label: "Restaurant",
        options: {
          filter: true,
          sort: true,
          searchable: true, 
          fixedHeader: true,
          responsive: "stacked",
          filterType: "textField",
        },
      },
  
      {
        name: "customerFirstName",
        label: "Customer Name",
        options: {
          filter: true,
          sort: true,
          searchable: true, 
          fixedHeader: true,
          responsive: "stacked",
          filterType: "textField",
        },
      },
  
      {
        name: "customerId",
        label: "Customer ID ",
        options: {
          filter: true,
          sort: true,
          searchable: true, 
          customFilterListOptions: { render: (v) => `UID: ${v}` },
          fixedHeader: true,
          responsive: "stacked",
          filterType: "textField",
        },
      },
  
      {
        name: "planId",
        label: "Plan ID ",
        options: {
          filter: true,
          sort: true,
          searchable: true, 
          customFilterListOptions: { render: (v) => `UID: ${v}` },
          fixedHeader: true,
          responsive: "stacked",
          filterType: "textField",
        },
      },
      {
        name: "planName",
        label: "Plan Name ",
        options: {
          filter: true,
          sort: true,
          searchable: true, 
          customFilterListOptions: { render: (v) => `UID: ${v}` },
          fixedHeader: true,
          responsive: "stacked",
          filterType: "textField",
  
       
        },
      },
      {
        name: "startDate",
        label: "Start Date ",
        options: {
          filter: false,
          sort: true,
          searchable: true, 
          customFilterListOptions: { render: (v) => `UID: ${v}` },
          fixedHeader: true,
          responsive: "stacked",
          filterType: "textField",
  
       
        },
      },
      {
        name: "endDate",
        label: "End Date ",
        options: {
          filter: false,
          sort: true,
          searchable: true, 
          customFilterListOptions: { render: (v) => `UID: ${v}` },
          fixedHeader: true,
          responsive: "stacked",
          filterType: "textField",
  
       
        },
      },
      {
        name: "deliveryType",
        label: "Delivery Type ",
        options: {
          filter: false,
          sort: true,
          searchable: true, 
          customFilterListOptions: { render: (v) => `UID: ${v}` },
          fixedHeader: true,
          responsive: "stacked",
          filterType: "textField",
  
       
        },
      },
      {
        name: "paymentId",
        label: "Payment ID",
        options: {
          filter: true,
          sort: true,
          searchable: true, 
          customFilterListOptions: { render: (v) => `UID: ${v}` },
          fixedHeader: true,
          responsive: "stacked",
          filterType: "textField",
  
       
        },
      },
      {
        name: "paymentMode",
        label: "Payment Mode ",
        options: {
          filter: false,
          sort: true,
          searchable: true, 
          customFilterListOptions: { render: (v) => `UID: ${v}` },
          fixedHeader: true,
          responsive: "stacked",
          filterType: "textField",
  
       
        },
      },
        {
        name: "paymentDate",
        label: "Payment Date ",
        options: {
          filter: true,
          sort: true,
          searchable: true, 
          customFilterListOptions: { render: (v) => `UID: ${v}` },
          fixedHeader: true,
          responsive: "stacked",
          filterType: "textField",
  
       
        },
      },
      {
        name: "actualCount",
        label: "Meal Count",
        options: {
          filter: false,
          sort: true,
          searchable: true, 
          customFilterListOptions: { render: (v) => `UID: ${v}` },
          fixedHeader: true,
          responsive: "stacked",
          filterType: "textField",
  
       
        },
      },
      {
        name: "totalAmount",
        label: "Total Amount",
        options: {
          filter: true,
          sort: true,
          searchable: true, 
          customFilterListOptions: { render: (v) => `UID: ${v}` },
          fixedHeader: true,
          responsive: "stacked",
          filterType: "textField",
  
       
        },
      },
    ];
    const themeTable = createMuiTheme({
      overrides: {
        MUIDataTable: {
          root: {
            backgroundColor: "#FF000",
          },
          paper: {
            boxShadow: "none",
          },
        },
        MuiTableRow: {
          root: {
            "&:nth-of-type(odd)": {
              backgroundColor: "white !important",
            },
            "&:nth-of-type(even)": {
              backgroundColor: "#e4e8ef !important",
            },
          },
        },
  
        MUIDataTableHeadCell: {
          root: {
            backgroundColor: "#008000 !important",
          },
          data: {
            fontWeight: "bold",
            color: "white",
            fontSize: "14px",
          },
        },
      },
    });
  
      return (
        <div className="row loaderPostn">
          {loader && <RctSectionLoader />}
          <div className="col-md-12 col-lg-12 col-sm-12 col-xl-12 ">
            <Card style={{ padding: "inherit" }}>
              <div class="row">
                <div class="col-3 col-md-3 col-lg-3">
                  <div class="form-group">
                    <h3 className="me-auto main-hd">Subscription Report</h3>
                  </div>
                </div>
                <div class="col-7 col-md-7 col-lg-7 row">
                  <Card.Header
                    className="card-title main-card"
                    style={{ marginLeft: "200px" }}
                  >
                    
                    {/* <div class="col-4 col-md-4 col-lg-4 form-group main-frm-grp">
                      <label as="a" variant="badge badge-rounded badge-danger">
                        Restaurant
                      </label>
                      <Select
                        options={outletlist}
                        value={selectedrestarant}
                        closeMenuOnSelect={true}
                        // search
                        // name="stateCode"
                        placeholder="Choose"
                        // autoComplete="off"
                        onChange={(event) => {
                          setSelectedrestarant(event);
                        }}
                      />
                    </div> */}

                    <div class="col-4 col-md-4 col-lg-4 form-group main-frm-grp" style={{zIndex:"800"}}>
                      <Label for="startDate">
                        From Date<span class="text-danger">*</span>
                      </Label>
                      <DatePicker
                        dateFormat="dd-MM-yyyy"
                        // selectsStart
                    
                        selected={startDate}
                        // minDate={today}
                        //startDate={rangeStart}
                        // endDate={rangeEnd}
                        onChange={(e) => {
                          setDate(e);
                        }}
                        // value={menulistitem?.startDate}
                      />
                    </div>

                    <div class="col-4 col-md-4 col-lg-4 form-group main-frm-grp" style={{zIndex:"800"}}>
                      <Label for="startDate">
                        To Date<span class="text-danger">*</span>
                      </Label>
                      <DatePicker
                        dateFormat="dd-MM-yyyy"
                        selectsEnd
                        selected={endDate}
                        minDate={startDate}
                        startDate={startDate}
                        //endDate={rangeEnd}
                        onChange={(e) => {
                          setendDate(e);
                        }}
                        //  value={menulistitem?.endDate}
                      />
                    </div>

                    <div
                      class=" col-2 col-md-2 col-lg-2 mt-4  form-group"
                      style={{ width: "9.333333%" }}
                    >
                      <Button
                        className="mt-2 btn-primary"
                        variant="success dark btn-sm "
                        // disabled={restarantvalue.value == ""}
                        style={{
                          backgroundColor: "green",
                          borderRadius: "2px",
                          border: "0px solid",
                        }}
                        onClick={() => {
                          getSubscrptionReportsList();
                          setListmast(true);
                        }}
                      >
                        <i
                          // class="fas fa-plus"
                          onClick={() => {}}
                        >
                          Get{" "}
                        </i>{" "}
                      </Button>
                   
                      {/* } */}
                    </div>

                    <div
                      class=" col-2 col-md-2 col-lg-2 mt-4  form-group"
                      style={{ width: "9.333333%" }}
                    >
                      <Tooltip title={"Excel Template"}>
                        <IconButton>
                          <CloudDownloadOutlined
                            onClick={() => {
                              
                              exceldownload();
                            }}
                          />
                        </IconButton>
                      </Tooltip>
                      </div>


                  </Card.Header>
                </div>

                <Card.Body
                  className="scroll-tbl-fix-header"
                  style={{ padding: "0.875rem" }}
                >
                    <RctCollapsibleCard fullBlock>
              <RctCollapsibleCard fullBlock>
                <MuiThemeProvider theme={themeTable}>
                  <MUIDataTable
                    title={""}
                    data={reports}
                    columns={columns}
                    options={options}
                    columOrder={columns}
                    className={"MuiTabCusCls"}
                  />
                </MuiThemeProvider>
              </RctCollapsibleCard>
            </RctCollapsibleCard>
                  {/* <Table responsive stripped style={{}}>
                    <thead>
                      <tr>
                        <th>Restaurant</th>
                        <th>Customer Name</th>
                        <th>Customer ID</th>
                        <th>Plan ID</th>
                        <th>Plan Name</th>
                        <th>Start Date</th>
                        <th>End Date</th>
                        <th> Delivery Type</th>
                        <th>Payment Id</th>
                        <th> Payment Mode</th>
                        <th>Payment Date</th>                        
                        <th> Meal Count</th>
                        <th style={{ textAlign: "right" }}>Total Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      {reports &&
                        reports.map((items) => {
                          console.log("items",items);
                          return (
                            <tr>
                              <td>{items.outletName}</td>
                              <td>{items.customerFirstName}</td>
                              <td>{items.customerId}</td>
                              <td>{items.planId}</td>
                              <td>{items.planName}</td>
                              <td>{items.startDate}</td>
                              <td>{items.endDate}</td>
                              <td>{items.deliveryType}</td>
                              <td>{items.paymentId}</td>
                              <td>{items.paymentMode}</td>
                              <td>{items.paymentDate}</td>
                              <td>{items.actualCount}</td>
                              <td style={{ textAlign: "right" }}>
                                {" "}
                                ₹ {items.totalAmount}
                              </td>
                            </tr>
                          );
                        })}
                      { listmast == true && reports?.length <= 0 ? (
                        <div
                          style={{
                            color: "red",
                            textAlign: "center",
                            fontSize: "150%",
                          }}
                        >
                          {" "}
                          No Data Found{" "}
                        </div>
                      ) : (
                        setReports
                      )}
                    </tbody>
                  </Table> */}
                </Card.Body>
              </div>
            </Card>
          </div>
        </div>
      );
}

export default SubscriptionReports